import { RouteConfig } from 'vue-router';
import MswPartnerResources from './components/msw-partner-resources.vue';

const route:RouteConfig = {
  path: 'claims',
  component: MswPartnerResources,
};

export function getDefaultParams() {
  return {};
}

export default route;
